module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_passing_yds/orange-9d91e9a900fd3b7239e18e5aa61cd24a.svg";